// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3wh2q","question":"Question_question__22KdZ","description":"Question_description__S3A6B"};